var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.page,{tag:"component"})],1),_vm._v(" "),_c('button',{staticClass:"returnTop flex-row",attrs:{"id":"button-to-scroll-top"},on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("./img/slider_accueil/fleche.svg"),"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9a07246","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 307
// module chunks = 0